import React from 'react';
import { Route } from 'react-router-dom';

import Show from 'components/Show';
import Update from 'components/Update';

import Me from 'containers/Me';
import Home from 'containers/Parent/Home';
import Courses from 'containers/Parent/Courses';
import Exams from 'containers/Parent/Exams';
import Marks from 'containers/Parent/Marks';
import Materials from 'containers/Parent/Materials';
import Webinars from 'containers/Parent/Webinars';
import Payments from 'containers/Parent/Payments';
import Articles from 'containers/Shared/Articles';

import { useAppStore } from 'store/useAppStore';

const Parent = () => {
	const update = useAppStore(state => state.update);

	return (
		<div className="app__content">
			{/* App's version update notification */}
			<Show if={update}>
				<Update />
			</Show>
			
			<Route path="/" exact>
				<Home />
			</Route>

			<Route path="/articles">
				<Articles />
			</Route>

			<Route path="/me">
				<Me />
			</Route>

			<Route path="/courses">
				<Courses />
			</Route>

			<Route path="/webinars">
				<Webinars />
			</Route>

			<Route path="/exams">
				<Exams />
			</Route>

			<Route path="/marks">
				<Marks />
			</Route>

			<Route path="/materials">
				<Materials />
			</Route>

			<Route path="/payments">
				<Payments />
			</Route>
		</div>
	);
};

export default Parent;
